module.exports = __webpack_public_path__ + "img/banner-brooks.4f64bb8f.png";